import { useContext, useEffect  } from "react";
import { AuthenticationContext } from "../contexts/authentication-context";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { tokenRequest } from "../auth-config";


export const useAcquireToken = () => {
  const { instance, accounts } = useMsal();

  const acquireToken = async (): Promise<string | null> => {
    const account = accounts[0]; // adjust if supporting multiple accounts
    if (!account) return null;

    try {
      const response = await instance.acquireTokenSilent({
        ...tokenRequest,
        account,
      });
      return response.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const response = await instance.acquireTokenPopup({
            ...tokenRequest,
            account,
          });
          return response.accessToken;
        } catch (popupError) {
          console.error("Popup token acquisition failed:", popupError);
        }
      } else {
        console.error("Silent token acquisition failed:", error);
      }

      return null;
    }
  };

  return { acquireToken };
};


export const useMSALInterceptor = () => {
  const { acquireToken } = useAcquireToken();
  const apiDomains = ["mytimeverse.com", "inviteuser-usc-af.azurewebsites.net"];

  useEffect(() => {
    const { fetch: originalFetch } = window;

    window.fetch = async (...args: any[]) => {
      const [resource, config = {}] = args;
      const url = new URL(resource);

      if (apiDomains.some(domain => url.hostname.includes(domain))) {
        try {
          const token = await acquireToken();
          if (token) {
            config.headers = new Headers(config.headers || {});
            config.headers.set("Authorization", `Bearer ${token}`);
          }
        } catch (error) {
          console.error("Fetch interceptor token error:", error);
        }
      }

      return originalFetch(resource, config);
    };

    return () => {
      window.fetch = originalFetch; // restore original fetch on unmount
    };
  }, [acquireToken]);
};



/*export const useMSALInterceptor = () => {
  // get the MSAL instance and the accounts
  const {acquireToken, accessToken} = useContext(AuthenticationContext)!;
  //const accessToken = useContext(AuthenticationContext)?.accessToken;
  const apiDomains = ["mytimeverse.com", "inviteuser-usc-af.azurewebsites.net", "localhost"];
  
  // setup an effect that runs whenever the instance or account changes
  useEffect(() => {

    const fetchAccessToken = async () => {
      try {
        // Ensure to call acquireToken to refresh the token if needed
        await acquireToken();
        //console.log("Updated AccessToken:", accessToken);
        // Now you have the most up-to-date accessToken
      } catch (error) {
        console.error("Error fetching access token:", error);
      }
    };

    
    const setTokenAndFetch = async () => {

      // save the original window.fetch function
      const { fetch: originalFetch } = window;

      // override window.fetch to add the authorization header
      window.fetch = async (...args: any[]) => {
        const [resource, config ] = args;
        const url = new URL(resource);
        
        if (apiDomains.some(domain => url.hostname.includes(domain))) {
            if(accessToken)
            {
              config.headers.set('Authorization', 'Bearer ' + accessToken);
            }
        }
        
        // call the original fetch function with the resource and configuration
        const response = await originalFetch(resource, config);
        return response;
      };
    };
    // run the setTokenAndFetch function
    fetchAccessToken();

    setTokenAndFetch();
  }, [accessToken]);
};*/